import Biotecnologia from '../../../models/biotecnologia'
import Cereal from '../../../models/cereal/cereal'
import CerealVariedad from '../../../models/cereal/cereal_variedad'

export function requestBiotecnologiasByCereal (cereal = null) {
  return (dispatch, getState) => {
    const state = getState()
    const {
      selectedCerealEspecie
    } = state.cereal

    cereal = cereal || selectedCerealEspecie
    dispatch({ type: 'REQUEST_BIOTECNOLOGIAS' })
    return Biotecnologia.getBiotecnologiasByCereal(cereal)
      .then(biotecnologias => {
        dispatch({
          type: 'RECEIVE_BIOTECNOLOGIAS',
          biotecnologias })
      })
      .catch(_ => dispatch({
        type: 'RECEIVE_BIOTECNOLOGIAS',
        biotecnologias: []
      }))
  }
};

export function setBiotecnologia (biotecnologia) {
  return dispatch => {
    dispatch({ type: 'SET_BIOTECNOLOGIA', biotecnologia })
  }
};

export function requestCerealEspecie (claveCereal, callback = null) {
  return async dispatch => {
    dispatch({ type: 'REQUEST_CEREAL_ESPECIE' })
    return Cereal.getDatosCereal(await claveCereal)
      .then(cerealEspecie => {
        dispatch({
          type: 'RECEIVE_CEREAL_ESPECIE',
          cerealEspecie })
        callback && callback(cerealEspecie)
      })
      .catch(_ => dispatch({
        type: 'RECEIVE_CEREAL_ESPECIE',
        cerealEspecie: null
      }))
  }
};

export function requestCerealEspecies () {
  return dispatch => {
    dispatch({ type: 'REQUEST_CEREAL_ESPECIES' })
    return Cereal.getCereales()
      .then(cerealEspecies => {
        dispatch({
          type: 'RECEIVE_CEREAL_ESPECIES',
          cerealEspecies })
        dispatch(getVariedades())
        /* dispatch(setCerealEspecie(cerealEspecies[0].nombreCorto)); */
        // dispatch(setCerealEspecie('UNDEF'));
      })
      .catch(_ => dispatch({
        type: 'RECEIVE_CEREAL_ESPECIES',
        cerealEspecies: []
      }))
  }
};

export function setCerealEspecie (cerealEspecie) {
  return dispatch => {
    dispatch({ type: 'SET_CEREAL_ESPECIE', cerealEspecie })
    dispatch(getVariedades())
    console.log('setCerealEspecie', cerealEspecie)
  }
};

export function getVariedades () {
  return (dispatch, getState) => {
    const state = getState()
    const { cereal: { selectedCerealEspecie } } = state
    dispatch({ type: 'REQUEST_CEREAL_VARIEDADES' })
    return CerealVariedad.getVariedades(selectedCerealEspecie)
      .then(variedades => dispatch({
        type: 'RECEIVE_CEREAL_VARIEDADES',
        cerealVariedades: variedades
      }))
      .catch(_ => dispatch({
        type: 'RECEIVE_CEREAL_VARIEDADES',
        cerealVariedades: []
      }))
  }
}

export function setCerealEspecieConVariedad (cerealEspecie, variedad) {
  return dispatch => {
    dispatch({ type: 'SET_CEREAL_ESPECIE', cerealEspecie })
    dispatch(getVariedad(cerealEspecie, variedad))
  }
};

export function getVariedad (cerealEspecie, variedad) {
  return (dispatch, getState) => {
    dispatch({ type: 'REQUEST_CEREAL_VARIEDAD' })
    return CerealVariedad.getVariedad(cerealEspecie, variedad)
      .then(variedad => dispatch({
        type: 'RECEIVE_CEREAL_VARIEDADES',
        cerealVariedades: variedad
      }))
      .catch(_ => dispatch({
        type: 'RECEIVE_CEREAL_VARIEDADES',
        cerealVariedades: []
      }))
  }
}
